import React from 'react';
import { Container, Col, Row, Card } from 'react-bootstrap';
import { Helmet } from 'react-helmet';  // Import Helmet for SEO
import BehavioralTherapyImg from '../img/behave.png'; // Replace with the relevant image for Behavioral Therapy

const Behavioral_Therapy = () => {
    const cardData = [
        {
            id: 1,
            title: 'Cognitive Behavioral Therapy',
            text: 'Cognitive Behavioral Therapy is a widely used form of psychotherapy that focuses on identifying and changing negative thought patterns and behaviors. It is effective for treating a variety of mental health conditions such as anxiety, depression, and stress. CBT helps individuals develop healthier thinking habits and coping strategies.',
        },
        {
            id: 2,
            title: 'Dialectical Behavior Therapy (DBT)',
            text: 'Dialectical Behavior Therapy (DBT) is a type of therapy designed to help individuals with emotion regulation issues, particularly those with borderline personality disorder (BPD). DBT combines cognitive-behavioral techniques with mindfulness strategies to help individuals manage intense emotions, improve relationships, and cope with distress.',
        },
        {
            id: 3,
            title: 'Exposure Therapy',
            text: 'Exposure Therapy is a behavioral treatment that helps individuals gradually confront and overcome their fears in a controlled and safe environment. It is commonly used for treating anxiety disorders, phobias, and PTSD. By systematically exposing the person to feared situations or thoughts, the therapy helps to reduce anxiety over time.',
        },
        {
            id: 4,
            title: 'Behavior Modification',
            text: 'Behavior Modification involves using reinforcement strategies to encourage positive behaviors and reduce undesired ones. This approach is commonly used for individuals with autism, ADHD, or other behavioral disorders. It uses techniques such as reward systems and reinforcement to promote desirable behaviors and teach new skills.',
        },
        {
            id: 5,
            title: 'Acceptance and Commitment Therapy',
            text: 'Acceptance and Commitment Therapy is a therapeutic approach that encourages individuals to accept their thoughts and feelings rather than fighting or avoiding them. ACT helps people commit to values-driven actions while developing psychological flexibility. It is often used to treat anxiety, depression, and chronic pain.',
        },
        {
            id: 6,
            title: 'Contingency Management',
            text: 'Contingency Management is a behavioral therapy that reinforces desired behaviors by offering rewards for specific actions. It is widely used in substance abuse treatment, helping individuals achieve abstinence by providing tangible incentives for meeting treatment goals, such as staying drug-free. Contingency management is a behavioral treatment.',
        },
    ];

    return (
        <div>
            <Helmet>
                <title>Behavioral Therapy | Treatment for Anxiety, Depression, and More</title>
                <meta name="description" content="Learn about various behavioral therapies such as Cognitive Behavioral Therapy, DBT, Exposure Therapy, and more to help treat mental health conditions like anxiety, depression, PTSD, and more." />
                <meta name="keywords" content="Behavioral Therapy, Cognitive Behavioral Therapy, DBT, Exposure Therapy, Anxiety Treatment, Depression Therapy, Mental Health Treatment, Therapy Techniques" />
                <meta name="author" content="Your Company Name" />
                <meta property="og:title" content="Behavioral Therapy | Treatment for Anxiety, Depression, and More" />
                <meta property="og:description" content="Explore various behavioral therapy techniques like CBT, DBT, and Exposure Therapy to manage mental health conditions. Learn more about therapy options available." />
                <meta property="og:image" content={BehavioralTherapyImg} />
                <meta property="og:url" content="https://yourwebsite.com/behavioral-therapy" />
            </Helmet>

            <Container>
                <Row>
                    <Col xs={12} sm={6} md={6} lg={6} className='mb-5'>
                        <img src={BehavioralTherapyImg} alt="Behavioral Therapy" className='img-fluid h-100 w-100 rounded-md'/>
                    </Col>
                    <Col xs={12} sm={6} md={6} lg={6} className='mb-5'>
                        <h1 style={{fontFamily:'monospace'}} className='mb-4'>Behavioral Therapy</h1>
                        <p style={{fontSize:'20px', fontFamily:'initial'}}>Behavioral therapy is a broad term used to describe various therapeutic approaches that focus on modifying unhealthy behaviors. These therapies are based on the principles of learning theory and aim to change patterns of behavior that cause distress or dysfunction.</p>
                        <p style={{fontSize:'20px', fontFamily:'initial'}}>The goal of behavioral therapy is to increase adaptive behaviors while reducing maladaptive ones, improving overall well-being and quality of life for individuals seeking treatment.</p>
                    </Col>
                </Row>
            </Container>

            <Container className='mb-5'>
                <Row>
                    {cardData.map((card) => (
                        <Col xs={12} sm={6} md={6} lg={6} className="g-4" key={card.id}>
                            <Card className='bg-info-subtle'>
                                <Card.Body>
                                    <Card.Title style={{color:'#093c60'}} className=' fw-bold'>{card.title}</Card.Title>
                                    <Card.Text>{card.text}</Card.Text>
                                </Card.Body>
                            </Card>
                        </Col>
                    ))}
                </Row>
            </Container>
        </div>
    );
}

export default Behavioral_Therapy;
